import { getDataFromService } from '../../service';
import { MEMBER_PROFILE_SERVICE } from '../constant/app.properties';

const {
  REACT_APP_SERVICE_URL,
} = window.weeksWebCloudConfig;

export const getFavoriteResorts = ({ subscriberId }) => async (dispatch) => {
  const memberUrl = `${REACT_APP_SERVICE_URL}${MEMBER_PROFILE_SERVICE}/${subscriberId}/preferences/favorites-resort`;

  const serviceResponse = await getDataFromService({ url: memberUrl, method: 'GET', customerID: subscriberId });
  if (serviceResponse.status === 200) {
    // console.log(serviceResponse, 'serviceResponse');
    const listOfFavoriteResorts = serviceResponse.data.map(
      eachResortInfo => eachResortInfo?.resortID,
    );
    // dispatch(fetchFavoriteResortsSuccess(listOfFavoriteResorts));
    dispatch({ type: 'update_resort_Data', data: listOfFavoriteResorts });
  } else {
    dispatch({ type: 'fav_resort_failure', data: true });
    // dispatch(logErrorMessage(serviceResponse, 'Favorites Get Favorite Resorts'));
  }
};
